import { styled } from "@mui/material";

import { DialogBlurBackdrop } from "styled";

export const StyledDialog = styled(DialogBlurBackdrop)({});
export const StyledImg = styled("img")({
  cursor: "zoom-out",
});
